/**
 * @flow
 * @relayHash 2c454bc4983f380df08df297339f29fa
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteFormTemplateInput = {
  clientMutationId?: ?string,
  id: string,
};
export type ActionsComponent_deleteFormTemplateMutationVariables = {|
  input: DeleteFormTemplateInput
|};
export type ActionsComponent_deleteFormTemplateMutationResponse = {|
  +deleteFormTemplate: ?{|
    +deletedFormTemplateId: ?string
  |}
|};
export type ActionsComponent_deleteFormTemplateMutation = {|
  variables: ActionsComponent_deleteFormTemplateMutationVariables,
  response: ActionsComponent_deleteFormTemplateMutationResponse,
|};
*/


/*
mutation ActionsComponent_deleteFormTemplateMutation(
  $input: DeleteFormTemplateInput!
) {
  deleteFormTemplate(input: $input) {
    deletedFormTemplateId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteFormTemplateInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteFormTemplate",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "DeleteFormTemplateInput!"
      }
    ],
    "concreteType": "DeleteFormTemplatePayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "deletedFormTemplateId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "ActionsComponent_deleteFormTemplateMutation",
  "id": null,
  "text": "mutation ActionsComponent_deleteFormTemplateMutation(\n  $input: DeleteFormTemplateInput!\n) {\n  deleteFormTemplate(input: $input) {\n    deletedFormTemplateId\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ActionsComponent_deleteFormTemplateMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "ActionsComponent_deleteFormTemplateMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '9340dd6e333227cacd768ebf71840f88';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Document/Template/Form/__generated__/ActionsComponent_deleteFormTemplateMutation.graphql.js